// extracted by mini-css-extract-plugin
export default {"descriptionListContainer":"TIHpJU2MxOBjDs6Xy3VO","statusContainer":"uviWKxCR33IPAfzzerQu","pass":"M9nKY2lXjf76gr7LxZNg","fail":"ef8mczxElSvWSGTWnffQ"};